import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    box: PropTypes.object,

};

export default class IconBox extends React.Component {
    constructor (props) {
        super(props);
    }


    render() {

        let isSafari = window.safari !== undefined;

        const {box} = this.props;
        const { img, title, subtitle, ctalabel, ctaroute, content, onClickFunc} = box;

        const cta = (
            <button className='icon-box-btn' onClick={onClickFunc}>{ctalabel}</button>
        );


        return (
            <div className='static-box-container'>
                <div className='copy-content-container'>
                    <div className='icon-container'>
                        <img className="anim--img" src={img}/>
                    </div>
                    <p className={isSafari === false ? "anim-title" : "anim-title-safari"}>{title}</p>
                    <div className="anim-box-hrdiv"></div>
                    <h2 className="anim-subtitle">{subtitle}</h2>
                    {content}
                </div>
                <div className='btn-container'>
                    {cta}
                </div>
            </div>
        )
    }
}

IconBox.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/IconBoxRow/IconBox.js